import React from 'react'
import ReactDOM from 'react-dom/client'
import Landing from './components/Landing'
import './handu.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Landing />
  </React.StrictMode>,
)
